<div>
    <span class="absolute pointer modal-close-svg pad-10">
      <svg  (click)="_bsModalRef.hide()" width="15" height="15"
          viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
              d="M15 1.51071L13.4893 0L7.5 5.98929L1.51071 0L0 1.51071L5.98929 7.5L0 13.4893L1.51071 15L7.5 9.01071L13.4893 15L15 13.4893L9.01071 7.5L15 1.51071Z"
              fill="#919aa2" />
      </svg>
    </span>
    <div *ngIf="couponLoading" class="flex align-center justify-center h100 loader-coupon">
        <div class="page-loader"></div>
    </div>
    <div *ngIf="selectedOffer && !couponLoading">
        <div class="modal-body coupon-code-pop text-center" *ngIf="voucherData && voucherData.success">
            <div class="merchant-logo-contain text-left">
              <img [default]="'https://images.poshvine.com/b/default-thumbnail-square.jpg'"
                    src="https://images.poshvine.com/logos/mastercard_logo.png">
            </div>
            <section class="mid-section">
              <div class="odder-name flex align-left">
                  <div class="modal-mer-logo">
                    <img [default]="'https://images.poshvine.com/b/default-thumbnail-square.jpg'" [src]="selectedOffer?.merchant_logo" class="img-fluid">
                  </div>
                  <div class="pad-left-20 merchant-info text-left">
                    <div class="offer-text flex align-center ellipse f500">{{selectedOffer?.merchant_name}}</div>
                    <div class="coupon-offer-name pad-top-5 fnt-13">{{selectedOffer?.offer_title}}</div>
                  </div>
              </div>

              <section class="voucher-sec pad-top-13 relative">
                <span class="circle c1"></span>
                <span class="circle c2"></span>
                <div *ngIf="selectedOffer?.offer_type != 'no_voucher'" class="coupon-code-box fnt-14 relative flex align-center pad-left-18 pad-right-34" >
                    <span class=""><ng-container i18n>Code</ng-container> : <b>{{voucherData?.voucher_code}}</b></span>
                    <button class="copy-icon pointer" (click)="showCopied(voucherData?.voucher_code)">
                        <svg  width="21" height="24" viewBox="0 0 21 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M15.4737 0H2.21053C0.994737 0 0 0.981818 0 2.18182V17.4545H2.21053V2.18182H15.4737V0ZM18.7895 4.36364H6.63158C5.41579 4.36364 4.42105 5.34545 4.42105 6.54545V21.8182C4.42105 23.0182 5.41579 24 6.63158 24H18.7895C20.0053 24 21 23.0182 21 21.8182V6.54545C21 5.34545 20.0053 4.36364 18.7895 4.36364ZM18.7895 21.8182H6.63158V6.54545H18.7895V21.8182Z" fill="#CF4500"/>
                        </svg>
                    </button>
                </div>
                <div *ngIf="selectedOffer?.offer_type == 'no_voucher'" class="coupon-code-box fnt-14 relative flex align-center justify-center" id="redemption_coupon_code">
                    <span class="">
                        <b i18n>No Voucher Required</b>
                    </span>
                </div>
                <svg class="mar-top-5" width="282" height="1" viewBox="0 0 282 1" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <line y1="0.5" x2="282" y2="0.5" stroke="#8D8B8B" stroke-dasharray="6 6"/>
                </svg>

                <div class="validity-box fnt-16">
                    <span id="validity_coupon_code_return"><ng-container i18n>Valid till</ng-container>: <span class="f600">{{selectedOffer?.end_date | date: 'mediumDate'}}</span></span>
                </div>
              </section>
            </section>

            <div class="coupon-code-footer pad-left-30 pad-right-30 pad-top-30">
                <div class="fnt-12 f300"><ng-container i18n>Please refer to the Offer </ng-container> <a i18n class="underline" (click)="_bsModalRef.hide(); sendOfferAnalyticsData('terms_conditions')" [routerLink]="'offers/details/'+ selectedOffer?.merchant_id +'/all/'+selectedOffer?.merchant_name+''" [queryParams]="{terms:true,offer_id: selectedOffer?.id}">Terms and Conditions</a> <ng-container i18n> on how to redeem this offer</ng-container>.</div>
                <div class="text-center go-to mar-top-15 mar-bot-25">
                    <img class="loader" width="31px" *ngIf="redeeming" src="./assets/img/icons/spin.gif">
                    <button i18n *ngIf="!redeeming" class="btn brand-btn shop_now_url fnt-14 cfff" (click)="goTo()">Redeem</button>
                </div>
            </div>
        </div>
        <div class="modal-body coupon-error text-center" *ngIf="voucherData && voucherData.success == false">
            <svg class="mar-top-48" fill="red" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px"
                viewBox="0 0 512.001 512.001" style="enable-background:new 0 0 512.001 512.001;" xml:space="preserve">
                <g>
                    <path
                        d="M503.839,395.379l-195.7-338.962C297.257,37.569,277.766,26.315,256,26.315c-21.765,0-41.257,11.254-52.139,30.102    L8.162,395.378c-10.883,18.85-10.883,41.356,0,60.205c10.883,18.849,30.373,30.102,52.139,30.102h391.398    c21.765,0,41.256-11.254,52.14-30.101C514.722,436.734,514.722,414.228,503.839,395.379z M477.861,440.586    c-5.461,9.458-15.241,15.104-26.162,15.104H60.301c-10.922,0-20.702-5.646-26.162-15.104c-5.46-9.458-5.46-20.75,0-30.208    L229.84,71.416c5.46-9.458,15.24-15.104,26.161-15.104c10.92,0,20.701,5.646,26.161,15.104l195.7,338.962    C483.321,419.836,483.321,431.128,477.861,440.586z" />
                </g>
                <g>
                    <rect x="241.001" y="176.01" width="29.996" height="149.982" />
                </g>
                <g>
                    <path
                        d="M256,355.99c-11.027,0-19.998,8.971-19.998,19.998s8.971,19.998,19.998,19.998c11.026,0,19.998-8.971,19.998-19.998    S267.027,355.99,256,355.99z" />
                </g>
            </svg>
            <div i18n class="fnt-16 ln-28 c333 error-line">Something went wrong. Please try again later!</div>
        </div>
    </div>
</div>
